export default __webpack_public_path__ + "static/media/CNo.86-4.5c49f542.jpg";